import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { BLUE, BLUE_D, INK, MUTE, LINE } from '@/styles/milk';
import { analyticsEnabled, getStoredConsent, setConsent } from '@/lib/analytics';

// GDPR/PIPEDA cookie-consent banner. Shows only in production (analyticsEnabled)
// when the user hasn't chosen yet. Analytics stays denied (Consent Mode v2)
// until "Accept".
export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (analyticsEnabled() && !getStoredConsent()) setVisible(true);
  }, []);

  if (!visible) return null;

  const choose = (granted) => { setConsent(granted); setVisible(false); };

  return (
    <div
      data-testid="consent-banner"
      className="fixed z-[60] left-4 right-4 bottom-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md rounded-2xl p-5"
      style={{
        background: '#FFFFFF',
        border: `1px solid ${LINE}`,
        boxShadow: '0 1px 2px rgba(33,46,64,.05), 0 20px 44px rgba(33,46,64,.16)',
        fontFamily: "'Work Sans', sans-serif",
      }}
    >
      <div className="flex items-start gap-3 mb-3">
        <div className="rounded-full p-2 flex-shrink-0" style={{ background: 'rgba(103,150,194,0.12)' }}>
          <Cookie size={16} style={{ color: BLUE_D }} />
        </div>
        <div>
          <p className="text-sm font-bold mb-1" style={{ color: INK }}>We value your privacy</p>
          <p className="text-xs leading-relaxed" style={{ color: MUTE }}>
            We use analytics cookies to understand how Milk is used and improve your
            experience. No analytics run until you accept. See our{' '}
            <Link to="/privacy" style={{ color: BLUE_D, textDecoration: 'underline' }}>Privacy Policy</Link>.
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 justify-end">
        <button
          data-testid="consent-decline"
          onClick={() => choose(false)}
          className="text-sm font-semibold rounded-full px-4 py-2"
          style={{ color: MUTE, background: 'transparent', border: `1px solid ${LINE}` }}
        >
          Decline
        </button>
        <button
          data-testid="consent-accept"
          onClick={() => choose(true)}
          className="text-sm font-bold rounded-full px-5 py-2"
          style={{ color: '#fff', background: BLUE, boxShadow: '0 8px 18px rgba(103,150,194,.30)' }}
        >
          Accept
        </button>
      </div>
    </div>
  );
}
